import React from "react";
import { Dayjs } from "dayjs";
import { styled } from "@mui/material/styles";
import { PickersDay, PickersDayProps } from "@mui/x-date-pickers/PickersDay";

export interface CustomDayProps extends PickersDayProps<Dayjs> {
  isStartOfRange?: boolean;
  isEndOfRange?: boolean;
  isInRange?: boolean;
}

const CustomDateRangeDay = styled(PickersDay, {
  shouldForwardProp: (prop) =>
    prop !== "isStartOfRange" &&
    prop !== "isEndOfRange" &&
    prop !== "isInRange",
})<CustomDayProps>(({ theme, isStartOfRange, isEndOfRange, isInRange }) => ({
  ...(isInRange && {
    backgroundColor: theme.colors.blue400,
    color: theme.palette.primary.contrastText,
    "&:hover, &:focus": {
      backgroundColor: theme.palette.primary.dark,
    },
  }),
  ...(isStartOfRange && {
    backgroundColor: theme.palette.primary.main,
  }),
  ...(isEndOfRange && {
    backgroundColor: theme.palette.primary.main,
  }),
})) as React.ComponentType<CustomDayProps>;

export const DateRangeDay: React.FC<CustomDayProps> = (props) => {
  return <CustomDateRangeDay {...props} />;
};
